import { render, staticRenderFns } from "./OverflowKPI.vue?vue&type=template&id=70e48309"
import script from "./OverflowKPI.vue?vue&type=script&lang=ts"
export * from "./OverflowKPI.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports